import { useRoutes, Navigate } from 'react-router-dom';

// routes
import { AuthRoutes, AdminRoutes } from './MainRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([{ path: '/', element: <Navigate to="/login" /> }, { path: '*', element: <Navigate to="/admin/users" /> }, AuthRoutes, AdminRoutes]);
}
